import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';

const EventCard = ({ image, title, description, dateFin, onClick }) => {
  const [timer, setTime] = useState('')

  React.useEffect(()=>{
    if(moment.utc(dateFin).isSame(moment(), 'D')) {
      const interval = setInterval(() => {
        const duration = moment.duration(moment().diff(moment.utc(dateFin)));
        const hours = duration.hours();
        const minutes = duration.minutes().toString().padStart(2, '0');
        const seconds = duration.seconds().toString().padStart(2, '0');
        if (hours < 0 && minutes < 0 && seconds < 0) {
          clearInterval(interval);
          setTime('00:00:00');
          return;
        }
        setTime(`${hours}:${minutes}:${seconds}`);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [dateFin])

  return (<>
    <Card sx={{ display:'flex', flex:1, flexDirection: 'column', textAlign: 'center', height: '100%', cursor: 'pointer', overflow:'hidden',
    transition: 'all 0.3s ease', '&:hover': { boxShadow: 3, transform: 'translateY(-2px)' }, border: moment.utc(dateFin).isSame(moment(), 'D') ? '3px solid red' : 'none' }} 
    onClick={moment.utc(dateFin).isBefore(moment(), 'D') || timer === '00:00:00' ? undefined : onClick}>
      <CardContent sx={{ flexGrow: 1, px: { xs: 1, md: 1 }, pt: { xs: 1, md: 1 } }}>

        {moment.utc(dateFin).isSame(moment(), 'D') && <Typography align='center' variant='body2' sx={{ color: 'red', pb: 1, borderRadius: 1 }}><span style={{fontSize:18}}>{timer}</span><br/>avant la fin des inscriptions</Typography>}

        <Box sx={{ height: { xs: 200, md: 250 }, overflow: 'hidden' }}>
          <img src={process.env.REACT_APP_API_URL.concat(image)} alt="Affiche évènement" height="100%" width="100%" style={{ objectFit: 'cover', borderRadius: 5 }} />
        </Box>
        <Typography variant="h6" component="h3" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.25rem' }, mt: 1 }}>{title}</Typography>
        {description && <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line', fontSize: { xs: '0.85rem', md: '0.875rem' } }}>{description}</Typography>}
      </CardContent>
      <Box sx={{ px: 2, py: 1, backgroundColor: (moment.utc(dateFin).isBefore(moment(), 'D') || timer==='00:00:00') ? 'red' : 'text.secondary', borderRadius: '0 0 4px 4px' }}>
        <Typography variant="h6" component="p" sx={{ fontSize: { xs: '0.9rem', md: '1rem' }, color: 'white' }}>{(moment.utc(dateFin).isBefore(moment(), 'D') || timer==='00:00:00') ? 'CLÔTURÉ' : 'RÉSERVER'}</Typography>
      </Box>
    </Card>

    </>
  );
};

export default EventCard;